import styled from 'styled-components';
import { Palette } from 'config';
import { IconWrap } from 'components/modals/modal/placement/EditPlacementModal.styled';

export const Container = styled.div`
  min-width: 638px;
  width: 65%;
  .MuiTableContainer-root {
    ::-webkit-scrollbar {
      width: 6px;
    }
    ::-webkit-scrollbar-thumb {
      background: ${Palette.PrimaryGray._300};
      border-radius: 8px;
    }
  }
`;

export const Form = styled.form`
  all: unset;
`;

export const Box = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(30, 50, 70, 0.1), 0px 1px 2px rgba(30, 50, 70, 0.06);
  margin-bottom: 8px;
  padding: 0 40px 32px;
`;

export const BtnGroup = styled.div`
  display: flex;
  margin: 24px 0 4px;
  gap: 16px;
`;

export const Head = styled.h2`
  padding: 32px 40px 0;
  margin-bottom: 32px;
  font-weight: 600;
  line-height: 32px;
`;
// export const Field = styled.div`
//   padding: 16px 40px 32px;
//   display: flex;
//   align-items: baseline;
//   align-items: center;
// `;

// export const Title = styled.h2`
//   font-weight: 500;
//   font-size: 0.875em;
//   line-height: 20px;
//   color: ${Palette.PrimaryGray._700};
// `;

export const headTableCellStyle = {
  bgcolor: Palette.PrimaryGray._000,
  height: '40px',
  padding: '12px 16px',
  color: Palette.PrimaryGray._500,
  fontWeight: '500',
  fontSize: '12px',
  lineHeight: '16px',
  borderRadius: '0px',
  width: '20px',
};

export const TableRow = styled.tr`
  height: 72px;
  :hover {
    background: ${Palette.PrimaryGray._000};
    ${IconWrap} {
      svg {
        fill: ${Palette.PrimaryGray._500};
      }
    }
    transition: background 0.2s linear;
  }
`;

export const TableCell = styled.th`
  font-weight: 500;
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
`;

export const TableContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  .question {
    svg {
      min-width: 20px;
      min-height: 20px;
    }
  }
`;

export const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  label {
    color: ${Palette.PrimaryGray._700};
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
  }
`;

export const CopyIcon = styled.span`
  font-weight: 400;
`;

export const StartPauseBtnWrap = styled.div`
  margin-left: 15px;
  min-width: 32px;
`;

export const paperStyle = {
  width: '100%',
  overflow: 'hidden',
  borderRadius: '0px',
  border: `1px solid ${Palette.PrimaryGray._200}`,
  boxShadow: '0',
};

export const SectionContainer = styled.div`
  margin-bottom: 8px;
`;
